<template>
  <div class="gui-flex gui-flex-rows">
    <div class="custom-scrollbar">
      <div class="pa-2 pr-0" :class="{'pa-4': $vuetify.breakpoint.smAndUp}">
        <v-snackbar v-model="ok_snackbar" :timeout="3000" color="green darken-3 white--text" :top="true">
          {{ ok_text }}
          <v-btn color="white" flat @click="ok_snackbar = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-snackbar>
        <v-snackbar v-model="error_snackbar" :timeout="3000" color="red darken-3 white--text" :top="true">
          {{ error_text }}
          <v-btn color="white" flat @click="error_snackbar = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-snackbar>
        <v-dialog
          v-model="dialogUpravit"
          persistent
          max-width="600px"
          transition="dialog-transition"
          v-if="dialogUpravit"
        >
          <v-card class="pa-0">
            <v-card-title primary-title>
              Upravit platbu v peněžence
            </v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <h4>Infomace o pohybu:</h4>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-2">
                <v-flex xs12 sm12>
                  Datum: {{item.datum | formatDate}}
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-1">
                <v-flex xs12 sm12>
                  Částka: {{item.castka | formatMoney}} {{item.mena.zkratka}}
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-1">
                <v-flex xs12 sm12>
                  Popis: {{item.popis}}
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-3">
                <v-flex xs12>
                  <v-form lazy-validation v-model="valid" ref="form_edit">
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field
                          label="Částka"
                          type="number"
                          :suffix="mena.zkratka"
                          v-model="edit_item.castka"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <!-- <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field
                          label="Poznámka"
                          :rules="rulesRequired"
                          v-model="edit_item.poznamka"
                        ></v-text-field>
                      </v-flex>
                    </v-layout> -->
                  </v-form>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green" depressed dark @click="edit" :loading="sending">Upravit</v-btn>
              <v-btn color="grey" flat @click="dialogUpravit=false" v-if="!sending">Zavřít</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="dialogPridat"
          persistent
          max-width="400px"
          transition="dialog-transition"
          v-if="dialogPridat"
        >
          <v-card class="pa-0">
            <v-card-title primary-title>
              Nahrát do peněženky
            </v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-form lazy-validation v-model="valid" ref="form">
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field
                          label="Částka"
                          type="number"
                          :rules="rules"
                          :suffix="mena.zkratka"
                          v-model="castka"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field
                          label="Poznámka"
                          :rules="rulesRequired"
                          v-model="poznamka"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green" depressed dark @click="add" :loading="sending">Přidat</v-btn>
              <v-btn color="grey" flat @click="dialogPridat=false" v-if="!sending">Zavřít</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="dialogUhrada"
          persistent
          max-width="1200px"
          transition="dialog-transition"
          v-if="dialogUhrada"
        >
          <v-card class="no__padding">
            <v-card-title class="pl-0">
              <h2>Úhrada z peněženky</h2>
            </v-card-title>
            <v-card color="grey lighten-4" class="pa-2 elevation-0">
              <v-card-text>
                <Loader v-if="searchingPair" skin="light" class="pt-5 pb-5"></Loader>
                <v-layout row wrap v-else>
                  <v-flex xs12>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <p class="mb-2"><strong>Výše platby:</strong></p>
                        <v-form v-model="uhrada_valid" lazy-validation ref="dialogUhradaForm">
                          <v-layout row wrap>
                            <v-flex xs12 sm4>
                              <v-text-field
                                label="Částka"
                                type="number"
                                :rules="rules"
                                suffix="Kč"
                                v-model="castka"
                                class="mr-3 mt-0"
                                @input="(e) => { novy_zustatek = aktualni_zustatek - (castka != null && !isNaN(castka) ? parseInt(castka) : 0) }"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-form>
                        <v-layout row wrap>
                          <v-flex class="caption">
                            Aktuální zůstatek {{ aktualni_zustatek | formatMoney }} Kč. <span v-if="!isNaN(castka) && parseInt(castka) >= 0">Nový zůstatek po úhradě {{ novy_zustatek | formatMoney }} Kč.</span>
                          </v-flex>
                        </v-layout>
                        <p class="mt-3"><strong>Návrhy pro platbu:</strong></p>
                        <div class="mt-3 mr-3 mb-3">
                          <p class="caption mt-2 mb-2" v-if="navrhy_sporeni.length>0"><strong>Spoření</strong></p>
                          <v-data-table
                            :headers="pairHeadersSporeni"
                            :items="navrhy_sporeni"
                            :pagination.sync="pagination"
                            :total-items="pagination.totalItems"
                            :rows-per-page-items="[25, 50, 100, 200]"
                            class="elevation-1 mt-0 mb-2"
                            item-key="id"
                            color="grey"
                            v-if="navrhy_sporeni.length>0"
                          >
                            <template slot="items" slot-scope="props">
                              <td><strong>{{ props.item.nazev_sporeni }}</strong></td>
                              <td><strong>{{ props.item.variabilni_symbol }}</strong></td>
                              <td>
                                <strong v-if="props.item.stav_sporeni=='probiha'">Probíhá</strong>
                              </td>
                              <td><strong>{{ props.item.mena.nazev }}</strong></td>
                              <td class="text-xs-right">
                                <v-btn color="primary" depressed small @click="uhradit('sporeni', props.item.id)">Uhradit spoření</v-btn>
                              </td>
                            </template>
                          </v-data-table>
                          <p class="caption mt-3" v-if="navrh_objednavky.length>0"><strong>Objednávky</strong></p>
                          <v-data-table
                            :headers="pairHeadersObjednavky"
                            :items="navrh_objednavky"
                            :pagination.sync="pagination"
                            :total-items="pagination.totalItems"
                            :rows-per-page-items="[25, 50, 100, 200]"
                            class="elevation-1 grey mb-2"
                            item-key="id"
                            color="grey"
                            v-if="navrh_objednavky.length>0"
                          >
                            <template slot="items" slot-scope="props">
                              <td><strong>{{ props.item.cislo_objednavky }}</strong></td>
                              <td><strong>{{ props.item.variabilni_symbol }}</strong></td>
                              <td><strong>{{ props.item.castka_celkem | formatMoney }} {{ props.item.mena.zkratka }}</strong></td>
                              <!-- <td><strong>{{ props.item.stav_objednavky }}</strong></td> -->
                              <td class="text-xs-right">
                                <v-btn color="primary" depressed small @click="uhradit('jednorazovy_nakup', props.item.id)">Uhradit objednávku</v-btn>
                              </td>
                            </template>
                          </v-data-table>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
            <v-card-actions class="mt-3 pr-0">
              <v-spacer></v-spacer>
              <v-btn color="grey lighten-3 elevation-0" @click="dialogUhrada=false">Zavřít</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-layout row wrap>
          <v-flex xs12 sm4 v-for="p in items" :key="'penezenka'+p.id" class="no__radius mb-4 pa-0" :class="{'pa-3': $vuetify.breakpoint.smAndUp}">
            <v-card class="mx-2 no__radius" :class="{ 'grey lighten-3': mena_id != p.mena.id, 'blue accent-3 white--text': mena_id == p.mena.id }" @click="mena_id=p.mena.id;mena=p.mena;">
              <v-card-text>
                <div>
                  <h2>{{p.mena.nazev}}</h2>
                </div>
                <div class="mt-3">
                  <p class="caption  mb-0" :class="{ 'grey--text': mena_id != p.mena.id, 'white--text': mena_id == p.mena.id }">Aktuální zůstatek</p>
                </div>
                <div>
                  <h2 class="mb-0">{{p.aktualni_zustatek | formatMoney}} {{p.mena.zkratka}}</h2>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-card v-if="!loading">
          <v-card-text>
            <v-btn dark depressed color="blue accent-3" class="ma-0 ml-3 mt-3" :class="{'v-btn--block':$vuetify.breakpoint.xs}" @click="addClick">Nahrát peníze do peněženky</v-btn>
            <v-btn dark depressed color="blue accent-3" class="ma-0 mt-3" :class="{'v-btn--block mt-2':$vuetify.breakpoint.xs, 'ml-3':$vuetify.breakpoint.smAndUp}" @click="uhraditClick">Uhradit nákup / spoření</v-btn>
            <v-layout row wrap v-if="pohledavky != null && pohledavky.length > 0" class="my-3">
              <v-flex xs12 class="mt-3">
                <h3 class="mx-3">Nedoplatky jednorázových nákupů</h3>
                <v-data-table
                  hide-actions
                  :headers="pohledavkyHeaders"
                  :items="pohledavky"
                >
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.variabilni_symbol }}</td>
                    <td class="text-xs-right">
                      {{ props.item.castka_celkem | formatMoney }} Kč
                    </td>
                    <td class="text-xs-right">
                      {{ props.item.castka_celkem_fixace | formatMoney }} Kč
                    </td>
                    <td class="text-xs-right">
                      {{ props.item.nedoplatek | formatMoney }} Kč
                    </td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 class="mt-3">
                <v-data-table
                  :headers="headers"
                  :items="platby"
                  :loading="loadingTable"
                  :pagination.sync="pagination"
                  :total-items="pagination.totalItems"
                  :rows-per-page-items="[25, 50, 100, 200]"
                >
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.datum | formatDate }}</td>
                    <td>{{ props.item.castka | formatMoney }} {{props.item.mena.zkratka}}</td>
                    <td>{{ props.item.variabilni_symbol }}</td>
                    <td>{{ props.item.popis }}</td>
                    <td><span v-if="props.item.stav=='sparovano'">Spárováno</span><span v-else-if="props.item.stav=='castecne_sparovano'">Spárováno</span><span v-else-if="props.item.stav=='nesparovano'" class="red--text">Nespárováno</span></td>
                    <td class="text-xs-right"><v-btn color="primary" class="ma-0" depressed @click="editClick(props.item)">Upravit</v-btn></td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading: true,
      pohledavkyHeaders: [
        { text: 'Číslo objednávky', value: 'variabilni_symbol', sortable: false },
        { text: 'Částka objednávky', value: 'castka_celkem', sortable: false, align: 'right' },
        { text: 'Částka fixace', value: 'castka_celkem_fixace', sortable: false, align: 'right' },
        { text: 'Nedoplatek', value: 'nedoplatek', sortable: false, align: 'right' }
      ],
      headers: [
        { text: 'Datum', value: 'datum' },
        { text: 'Částka', value: 'castka', sortable: false },
        { text: 'Variabilní symbol', value: "variabilni_symbol", sortable: false },
        { text: 'Popis transakce', value: "popis", sortable: false },
        { text: 'Stav', value: 'stav', sortable: false },
        { text: 'Akce', value: 'id', sortable: false, align: 'right' },
      ],
      mena_id: null,
      mena: null,
      loadingTable: false,
      items: [],
      timeout: null,
      counter: 0,
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 25,
        sortBy: "id",
        totalItems: 0
      },
      platby: [],
      dialogPridat: false,
      rules: [
        (v) => (!!v && !isNaN(v)) || "Částka musí být zadána"
      ],
      rulesRequired: [
        (v) => !!v || "Pole je vyžadováno"
      ],
      castka: null,
      valid: true,
      poznamka: null,
      sending: false,
      item: null,
      edit_item: null,
      dialogUpravit: false,
      ok_snackbar: false,
      ok_text: null,
      error_snackbar: false,
      error_text: null,
      dialogUhrada: false,
      searchingPair: false,
      pairHeadersSporeni: [
        { text: 'Název spoření', value: 'nazev_sporeni', sortable: false },
        { text: 'Variabilní symbol', value: 'variabilni_symbol', sortable: false },
        { text: 'Stav spoření', value: 'stav_sporeni', sortable: false },
        { text: 'Měna', value: 'mena', sortable: false },
        { text: '', value: 'id', sortable: false }
      ],
      pairHeadersObjednavky: [
        { text: 'Číslo nákupu', value: 'cislo_nakupu', sortable: false },
        { text: 'Variabilní symbol', value: 'variabilni_symbol', sortable: false },
        { text: 'Částka celkem', value: 'castka_celkem', sortable: false },
        { text: '', value: 'id', sortable: false }
      ],
      castka: null,
      navrhy_sporeni: [],
      navrh_objednavky: [],
      aktualni_zustatek: 0,
      novy_zustatek: 0,
      uhrada_valid: true,
      pohledavky: []
    }
  },
  watch: {
    mena_id () {
      this.loadPenezenka();
    },
    pagination: {
      handler () {
        this.loadPenezenka();
      },
      deep: true
    }
  },
  mounted: function() {
    window.API.get("osoby/"+this.$props.id+"/elektronicke-penezenky").then(function(body) {
      this.items = body;
      if (this.items.length > 0) {
        this.mena_id = this.items[0].mena.id;
        this.mena = this.items[0].mena;
      }
      this.loading = false;
    }.bind(this)).catch(function(err) {
      console.log(err);
    }.bind(this));
  },
  methods: {
    reload (f) {
      window.API.get("osoby/"+this.$props.id+"/elektronicke-penezenky").then(function(body) {
        body.forEach((e) => {
          var $f = this.items.filter((v) => {
            return v.mena.id == e.mena.id;
          });
          if ($f.length > 0)
            $f[0].aktualni_zustatek = e.aktualni_zustatek;
        });
        if (typeof f === "function")
          f();
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    loadPenezenka (f) {
      this.counter++;
      this.loadingTable = true;
      window.API.post("osoby/"+this.$props.id+"/elektronicke-penezenky/"+this.mena_id+"/search", {
        pagination: this.pagination,
        echo: this.counter,
        osoba: this.id,
        mena: this.mena_id
      }).then(function(body) {
        if (this.counter != body.echo)
          return;
        this.pohledavky = body.pohledavky;
        this.platby.replace(body.data);
        this.pagination.sortBy = body.sort.sortBy;
        this.pagination.descending = body.sort.descending;
        this.pagination.page = body.sort.page;
        this.pagination.rowsPerPage = body.sort.rowsPerPage;
        this.pagination.totalItems = body.sort.totalItems;
        this.loading = false;
        this.loadingTable = false;
        if (typeof f === "function")
          f();
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    addClick () {
      this.castka = null;
      this.poznamka = null;
      this.dialogPridat = true;
    },
    add () {
      if (this.$refs.form.validate()) {
        this.sending = true;
        window.API.post("osoby/"+this.$props.id+"/elektronicke-penezenky/"+this.mena_id+"", {
          castka: this.castka,
          poznamka: this.poznamka
        }).then(function(body) {
          if (body.created) {
            this.pagination.page = 1;
            this.reload(() => {
              this.loadPenezenka(() => {
                this.sending = false;
                this.dialogPridat = false;
              });
            });
          }
          else {
            this.sending = false;
          }
        }.bind(this)).catch(function(err) {
          this.sending = false;
          console.log(err);
        }.bind(this));
      }
    },
    editClick (v) {
      this.item = v;
      this.edit_item = window.th.copy(v);
      this.dialogUpravit = true;
    },
    edit () {
      if (this.$refs.form_edit.validate()) {
        this.sending = true;
        window.API.put("osoby/"+this.$props.id+"/elektronicke-penezenky/"+this.item.id+"", {
          castka: this.edit_item.castka,
          poznamka: null
        }).then(function(body) {
          if (body.updated) {
            this.reload(() => {
              this.sending = false;
              this.item.castka = this.edit_item.castka;
              this.dialogUpravit = false;
            });
          }
          else {
            this.sending = false;
          }
        }.bind(this)).catch(function(err) {
          this.sending = false;
          console.log(err);
        }.bind(this));
      }
    },
    uhraditClick () {
      this.dialogUhrada = true;
      this.searchingPair = true;
      window.API.get("osoby/"+this.$props.id+"/uhrada-navrhy").then(function(body) {
        this.navrhy_sporeni = body.sporeni;
        this.navrh_objednavky = body.objednavky;
        this.castka = body.penezenka.aktualni_zustatek;
        this.aktualni_zustatek = body.penezenka.aktualni_zustatek;
        this.novy_zustatek = body.penezenka.aktualni_zustatek - this.castka;
        this.searchingPair = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
        this.searchingPair = false;
      }.bind(this));
    },
    uhradit (typ, id) {
      if (this.$refs.dialogUhradaForm.validate()) {
        var castka = this.castka != null && !isNaN(this.castka) ? parseFloat(this.castka) : 0;
        if (castka > 0 && castka <= this.aktualni_zustatek) {
          this.searchingPair = true;
          window.API.post("osoby/"+this.$props.id+"/uhrada", {
            typ: typ,
            id: id,
            castka: this.castka
          }).then(function(body) {
            if (body.created) {
              this.reload(() => {
                this.loadPenezenka(() => {
                  this.dialogUhrada = false;
                  this.searchingPair = false;
                  this.ok_snackbar = true;
                  this.ok_text = "Úhradu byla provedena.";
                });
              });
            }
            else {
              this.searchingPair = false;
              this.error_snackbar = true;
              this.error_text = "Úhradu nebylo možné provést.";
            }
          }.bind(this)).catch(function(err) {
            console.log(err);
            this.searchingPair = false;
          }.bind(this));
        }
        else if (castka <= 0) {
          this.error_snackbar = true;
          this.error_text = "Částka musí být větší než 0.";
        }
        else if (castka > this.aktualni_zustatek) {
          this.error_snackbar = true;
          this.error_text = "Částka je vyšší než zůstatek.";
        }
      }
    }
  },
  props: {
    id: String
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/Klienti/ElektronickaPenezenka.vue